export default {
    label: {
        alignment: 'Alignment & Lists',
        attachments: 'Attachments',
        content: 'Content',
        insertion: 'Insertions',
        language: 'Language',
        styling: 'Font styling',
    },
    tools: {
        align: 'Align',
        alignLeft: 'Align left',
        alignCenter: 'Align center',
        alignRight: 'Align right',
        attributes: 'Insert attributes',
        bold: 'Bold',
        list: 'List',
        bulletList: 'Bullet list',
        blockQuote: 'Block quote',
        erase: 'Erase styling',
        italic: 'Italic',
        image: 'Insert embeded picture',
        isVideo: 'Watch your video presentation',
        justify: 'Justify',
        link: 'Insert link',
        orderedList: 'Ordered list',
        strikethrough: 'Strikethrough',
        textColor: 'Text color',
        textBackground: 'Text background color',
        underline: 'Underline',
        video: 'Create a video presentation',
        insertVehicle: 'Insert Vehicle',
    },
    characters: '{0} character | {0} characters',
    dropImage: 'Drop or upload an image',
    editSignature: 'Edit your signature',
    hideHistory: 'Hide email history',
    imageUrl: 'Image URL',
    insert: 'Insert',
    insertLink: 'Insert link',
    link: 'Link',
    originalCommunication: 'Append original lead information to the email.',
    originalLeadEmail: 'Original lead email',
    showHistory: 'Show email history',
    unlink: 'Unlink',
    uploadImage: 'Upload image',
    validUrl: 'Please enter a valid URL',
};
